import React, { useRef, useMemo } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const ParticleField = () => {
    const pointsRef = useRef();
    const isMobile = window.innerWidth < 1024;
    const count = isMobile ? 1200 : 2500;

    const [positions, phase] = useMemo(() => {
        const positions = new Float32Array(count * 3);
        const phase = new Float32Array(count);

        for (let i = 0; i < count; i++) {
            positions[i * 3] = (Math.random() - 0.5) * 50;
            positions[i * 3 + 1] = (Math.random() - 0.5) * 50;
            positions[i * 3 + 2] = (Math.random() - 0.5) * 50;
            phase[i] = Math.random() * Math.PI * 2;
        }
        return [positions, phase];
    }, [count]);

    useFrame((state) => {
        const time = state.clock.getElapsedTime();
        for (let i = 0; i < count; i++) {
            const i3 = i * 3;
            pointsRef.current.geometry.attributes.position.array[i3 + 1] += Math.sin(time + phase[i]) * 0.005;
        }
        pointsRef.current.geometry.attributes.position.needsUpdate = true;
        pointsRef.current.rotation.y = time * 0.02;
    });

    return (
        <points ref={pointsRef}>
            <bufferGeometry>
                <bufferAttribute
                    attach="attributes-position"
                    count={count}
                    array={positions}
                    itemSize={3}
                />
            </bufferGeometry>
            <pointsMaterial
                size={0.15}
                color="#3b82f6"
                transparent
                opacity={0.15}
                sizeAttenuation
                blending={THREE.NormalBlending}
            />
        </points>
    );
};

const ParticleBackground = () => {
    const isMobile = window.innerWidth < 1024;

    return (
        <div className="fixed inset-0 z-0 pointer-events-none bg-white">
            {!isMobile && (
                <Canvas camera={{ position: [0, 0, 20], fov: 75 }} dpr={1} gl={{ antialias: false, alpha: true }}>
                    <ambientLight intensity={0.8} />
                    <ParticleField />
                </Canvas>
            )}
            {/* Subtle Light Gradient Overlays */}
            <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white opacity-40" />
        </div>
    );
};

export default ParticleBackground;
